export function providerPublishingSeries(networks, fallback, start, end, bucketCount = 7) {
  const bucketSize = (end - start) / bucketCount;
  return fallback.map((series) => {
    const accounts = (networks.find((network) => network.platform === series.id)?.accounts || [])
      .filter((account) => account.postsCount != null && (Array.isArray(account.postSeries) || Array.isArray(account.topPosts)));
    if (!accounts.length) return series;
    const values = Array(bucketCount).fill(0);
    const points = accounts.flatMap((account) => account.postSeries?.length
      ? account.postSeries
      : Array.from(new Map((account.topPosts || []).map((post) => [post.id, post])).values())
        .map((post) => ({ date: post.publishedAt, value: 1 })));
    for (const point of points) {
      const date = new Date(point.date).getTime();
      if (!Number.isFinite(date) || date < start || date > end) continue;
      values[Math.min(bucketCount - 1, Math.floor((date - start) / bucketSize))] += Number(point.value || 0);
    }
    return { ...series, values };
  });
}

export function providerReportPosts(networks, globalPosts = [], platform = '', accountId = 'all') {
  const accountPosts = (networks || []).flatMap((network) => (network.accounts || []).flatMap((account) =>
    (account.topPosts || []).map((post) => ({
      ...post,
      platform: post.platform || network.platform,
      accountId: post.accountId || account.id
    }))));
  const seen = new Set();
  return [...globalPosts, ...accountPosts].filter((post) => {
    if (platform && post.platform !== platform) return false;
    if (accountId !== 'all' && String(post.accountId) !== String(accountId)) return false;
    if (!post.id) return true;
    const key = `${post.platform}:${post.accountId}:${post.id}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
